import { render, staticRenderFns } from "./QuestionsHygiene.vue?vue&type=template&id=19b4e9a8&scoped=true"
import script from "./QuestionsHygiene.vue?vue&type=script&lang=js"
export * from "./QuestionsHygiene.vue?vue&type=script&lang=js"
import style0 from "./QuestionsHygiene.vue?vue&type=style&index=0&id=19b4e9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4e9a8",
  null
  
)

export default component.exports